import { gsap, ScrollTrigger, smoothScrollObj, Modal } from "../layout"

import Swiper from 'swiper';
import { Pagination, Navigation, EffectFade, Autoplay } from 'swiper/modules';

function counting(number, target, duration) {
    let counts = setInterval(updated, duration);
    let upto = 0;
    function updated() {
        let count = document.querySelector(`${target}`);
        count.innerText = ++upto;
        if (upto === number) {
            clearInterval(counts);
        }
    }
}
function infoCountSection() {
    const infoCountSection = document.querySelector('.info-count');
    ScrollTrigger.create({
        trigger: infoCountSection,
        start: "top-=100 bottom-=15%",
        // markers: true,
        onEnter: () => {
            let year = parseInt(document.querySelector('.info-count__number.year').innerText.replace(/\D/g, ""));
            let project = parseInt(document.querySelector('.info-count__number.project').innerText.replace(/\D/g, ""));
            let client = parseInt(document.querySelector('.info-count__number.client').innerText.replace(/\D/g, ""));
            let location = parseInt(document.querySelector('.info-count__number.location').innerText.replace(/\D/g, ""));
            let satisfied = parseInt(document.querySelector('.info-count__number.satisfied').innerText.replace(/\D/g, ""));

            counting(year, '.info-count__number.year', 150);
            counting(project, '.info-count__number.project');
            counting(client, '.info-count__number.client');
            counting(location, '.info-count__number.location', 10);
            counting(satisfied, '.info-count__number.satisfied', 99);
        }
    });
}

function ourTeamSection() {
    const ourTeamWrapper = document.querySelector('.our-team__image-col');
    const ourTeamItem = document.querySelectorAll('.our-team__image-container');
    gsap.fromTo(ourTeamItem, {
        y: "-20%",
        autoAlpha: 0,
    }, {
        y: "0%",
        autoAlpha: 1,
        duration: 1,
        stagger: 0.2,
        ease: "ease",
        scrollTrigger: {
            trigger: ourTeamWrapper,
            start: "top-=100 bottom-=20%",
            // markers: true,
        },
    });

    const ourTeamRow = document.querySelector(".our-team > .theme-container > .row");
    const ourTeamTitle = document.querySelector(".our-team__title");
    let mm = gsap.matchMedia()
    mm.add("(min-width: 992px)", () => {
        ScrollTrigger.create({
            trigger: ourTeamRow,
            pin: ourTeamTitle,
            start: "top top+=100",
            end: "bottom center",
            // markers: true
        });
    })
}

function testimonialSection() {
    const testimonialSwiper = new Swiper(".testimonial__swiper", {
        modules: [ Navigation, Autoplay ],
        speed: 1000,
        spaceBetween: 20,
        autoplay: {
            delay: 5000,
            reverseDirection: false,
        },
        navigation: {
          nextEl: ".testimonial__next",
          prevEl: ".testimonial__prev",
        },
    });
}

document.addEventListener('DOMContentLoaded', () => {
    infoCountSection();
    ourTeamSection();
    testimonialSection();
})